export default __webpack_public_path__ + "static/media/fast-rewind-24-px.33812b52.svg";